export default "__VITE_ASSET__BgKQwS7G__";